var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearAllIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33327 8.59968C1.81257 9.12035 1.81257 9.96454 2.33327 10.4853L4.90519 13.0572H2.7238C2.35561 13.0572 2.05713 13.3557 2.05713 13.7239C2.05713 14.0921 2.35561 14.3905 2.7238 14.3905H13.3905C13.7586 14.3905 14.0572 14.0921 14.0572 13.7239C14.0572 13.3557 13.7586 13.0572 13.3905 13.0572H7.30383L13.647 6.71401C14.1677 6.19334 14.1677 5.34912 13.647 4.82842L10.8186 1.99999C10.2978 1.47929 9.45363 1.47929 8.93296 1.99999L2.33327 8.59968ZM5.21715 7.60141L3.27608 9.54248L6.10451 12.3709L8.04556 10.4298L5.21715 7.60141ZM6.15996 6.65859L8.98836 9.48701L12.7042 5.77123L9.87576 2.9428L6.15996 6.65859Z",
    fill: "#525866"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearAllIcon);
export default __webpack_public_path__ + "static/media/clearAllIcon.420c4d0501fa4d7998559755c8053b11.svg";
export { ForwardRef as ReactComponent };